import { render, staticRenderFns } from "./RatePlanList.vue?vue&type=template&id=13d73102"
import script from "./RatePlanList.vue?vue&type=script&lang=js"
export * from "./RatePlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports